import React from "react";
import ReactDOM from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import "./App.css";
import App from "./App";
import { oidcConfig, oidcEnabled } from "./auth";
import { installApiAuthInterceptor } from "./fetchInterceptor";

const API_BASE = process.env.REACT_APP_API_BASE || "https://your-api-gateway.execute-api.us-east-1.amazonaws.com/prod";

installApiAuthInterceptor({
	apiBase: API_BASE,
	getToken: () => window.__VP_AUTH_TOKEN || "",
});

const root = ReactDOM.createRoot(document.getElementById("root"));

const app = (
	<React.StrictMode>
		<App />
	</React.StrictMode>
);

root.render(
	oidcEnabled
		? <AuthProvider {...oidcConfig}>{app}</AuthProvider>
		: app
);
